import { IDropdownMenuItem } from "@atomaro/ui-kit/components/DropdownMenu/types";
import { useApiariesStore } from "entities/apiaries";
import { useDiaryStore } from "entities/diary";
import { DiaryRequestParams } from "entities/diary/model/types";
import { useDictionariesStore } from "entities/dictionaries";
import { useEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form"
// import { toast } from "react-toastify";
import { useDebounceCallback } from "shared/lib/debounce/useDebounce";
import { DiaryFiltersFormValues } from "shared/types";
import { areParamsEqual } from "../helpers/params";
import { useUserStore } from "entities/user";
import { formatISO } from "date-fns";

export type dictionaryItem = {
  id: string;
  name: string;
  isSelected: boolean;
}

const defaultLastReqestParams: Partial<DiaryRequestParams> = {
    inspectedAtFrom: null,
    inspectedAtTo: null,
    framesFrom: "",
    framesTo: "",
    broodFrom: "",
    broodTo: "",
    strengthFrom: "",
    strengthTo: "",
    dictionariesIds: [],
    hasAttachments: null,
    commentKeyWords: [],
    hiveIds: [],
    sortBy: "updatedAt",
    sort: "DESC",
    page: {
        "index": 0,
        "size": 10
    }
}

export const useDiaryFilters = () => {
  const dictionaries = useDictionariesStore(s => s.dictionaries);
  const apiaryId = useApiariesStore(state => state.currentApiaryId);
  const currentApiary = useApiariesStore(state => state.currentApiary);
  const getDiaryEntriesFromServer = useDiaryStore(s => s.getDiaryEntriesFromServer);
  // const currentPage = useDiaryStore(s => s.currentPage);
  const pageSize = useDiaryStore(s => s.pageSize);
  const usersList = useUserStore(s => s.usersList);
  const userInfo = useUserStore(state => state.userInfo);
  
  const shortFiltersLabelsDefault = {
    frames: '',
    strength: '',
    brood: '',
    dictionariesIds: '',
    commentKeyWords: '',
    hasAttachments: '',
    author: '',
  }

  const {
    control,
    getValues,
    setValue,
    resetField,
    reset,
  }  = useForm<DiaryFiltersFormValues>({
    defaultValues: {
      authorIds: [],
      inspectedAtFrom: null,
      inspectedAtTo: null,
      framesFrom: '',
      framesTo: '',
      broodFrom: '',
      broodTo: '',
      strengthFrom: '',
      strengthTo: '',
      dictionariesIds: [],
      hasAttachments: null,
      commentKeyWords: [],
      hiveIds: [],
      sortBy: 'updatedAt',
      sort: 'DESC'
    }
  })

  const formValues = useWatch({control})

  const [ isFiltersOpen, setIsFiltersOpen ] = useState<boolean>(false);
  const [ dictionaryItems, setDictionaryItems ] = useState<dictionaryItem[]>([]);
  const [ settedFiltersCounter, _setSettedFiltersCounter ] = useState<number>(0);
  const [ shortFilterOpenSelector, setShortFilterOpenSelector ] = useState<string | null>(null);
  const [ shortFiltersLabels, setShortFiltersLabels ] = useState<{[key: string]: string}>(shortFiltersLabelsDefault)
  const setActiveDateFilter = useDiaryStore((s) => s.setActiveDateFilter);

  const lastRequestParams = useRef<Partial<DiaryRequestParams>>(defaultLastReqestParams);
  const lastSortValue = useRef<string>('updatedAt')

  const onRangeChange = (name: keyof DiaryFiltersFormValues, value: string) => {
    setValue(name, value.replace(/[^\d]/g, ''));
  }
  const onResetItems = (names: (keyof DiaryFiltersFormValues)[]) => {
    for (let index = 0; index < names.length; index++) {
      const name = names[index];
      resetField(name);
    }
  }

  const onDictionaryItemClick = (id: string) => {
    const ids = getValues('dictionariesIds');
    if (ids.includes(id)) {
      const index = ids.findIndex(el => el === id);
      if (index >= 0) {
        ids.splice(index, 1);
      }
    } else {
      ids.push(id);
      setValue('dictionariesIds', ids);
    }
    setDictionaryItems(dictionaries.map(dictionary => {
      return {
        id: dictionary.id,
        name: dictionary.name,
        isSelected: getValues('dictionariesIds')?.includes(dictionary.id) || false
      }
    }))
  }

  const onDictionaryReset = () => {
    setValue('dictionariesIds', []);
    setDictionaryItems(dictionaries.map(dictionary => {
      return {
        id: dictionary.id,
        name: dictionary.name,
        isSelected: getValues('dictionariesIds')?.includes(dictionary.id) || false
      }
    }))
  }

  const setHasAttachments = (value: boolean) => {
    setValue('hasAttachments', value);
  }

  const onDrawerClose = () => {
    setIsFiltersOpen(false);
  }

  // const calcFiltersCounter = () => {
  //   let counter = 0;
  //   const keys = Object.keys(getValues()) as (keyof DiaryFiltersFormValues)[];
  //   for (let index = 0; index < keys.length; index++) {
  //     const key: keyof DiaryFiltersFormValues = keys[index];
  //     const value = getValues(key);

  //     if (key.includes('sort')) continue;

  //     if (typeof value !== 'boolean') {
  //       if (!value) continue;
  //     }
  //     switch (typeof value) {
  //       case 'string':
  //         if (value.trim()) {
  //           counter++
  //         }
  //         break;
  //       case 'object':
  //         if (Array.isArray(value)) {
  //           if (value.length) {
  //             counter++;
  //           }
  //         } else {
  //           counter++;
  //         }
  //         break;
  //       case 'boolean':
  //         if (value !== null) counter++
  //         break;
      
  //       default:
  //         break;
  //     }
  //   }
    
  //   return counter
  // }
  
  const onCommentChange = (value: string[]) => {
    setValue('commentKeyWords', value, { shouldDirty: true, shouldValidate: false });
    // Обновляем метки сразу после изменения
    setShortFiltersLabel();
  };

  const onHivesChange = (hives: IDropdownMenuItem[]) => {
    setValue('hiveIds', hives.map(el=>`${el.key}`))
    onDrawerSubmitDebounced();
  }

  const setShortFiltersLabel = () => {
    const values = getValues();
    const obj = shortFiltersLabelsDefault;

    let framesLabel = ``;
    if (values.framesFrom) {
      framesLabel += `от ${values.framesFrom}`
    }
    if (values.framesTo) {
      framesLabel += ` до ${values.framesTo}`
    }
    obj.frames = framesLabel

    let strengthLabel = ``;
    if (values.strengthFrom) {
      strengthLabel += `от ${values.strengthFrom}`
    }
    if (values.strengthTo) {
      strengthLabel += ` до ${values.strengthTo}`
    }
    obj.strength = strengthLabel

    let broodLabel = ``;
    if (values.broodFrom) {
      broodLabel += `от ${values.broodFrom}`
    }
    if (values.broodTo) {
      broodLabel += ` до ${values.broodTo}`
    }
    obj.brood = broodLabel

    let dictionariesLabel = '';
    if (values.dictionariesIds.length) {
      const firstDict = dictionaries.find(el => el.id === values.dictionariesIds[0])
      dictionariesLabel += firstDict?.name;

      if (values.dictionariesIds.length - 1 > 0) {
        dictionariesLabel += ` +${values.dictionariesIds.length - 1}`
      }
    }
    obj.dictionariesIds = dictionariesLabel;

    let commentKeyWordsLabel = '';
    if (values.commentKeyWords.length) {
      commentKeyWordsLabel += values.commentKeyWords[0];
      if (values.commentKeyWords.length - 1 > 0) {
        commentKeyWordsLabel += ` +${values.commentKeyWords.length - 1}`;
      }
    }
    obj.commentKeyWords = commentKeyWordsLabel;

    let hasAttachmentsLabel = '';
    if (values.hasAttachments !== null) {
      hasAttachmentsLabel += values.hasAttachments===true ? 'Есть' : 'Отсутствуют'
    }
    obj.hasAttachments = hasAttachmentsLabel;

    let authorLabel = '';
    if (values.authorIds.length) {
      if (values.authorIds.length > 1) {
        authorLabel = values.authorIds.length.toString()
      } else {
        authorLabel = usersList.find(el => el.id === values.authorIds[0])?.name.first || '';
      }
    }
    obj.author = authorLabel;
    
    setShortFiltersLabels(obj);
  }

  const onDrawerSubmit = async (_isProgramming: boolean = false, ignoreEqual: boolean = false) => {
  // ... ваш код

  if (apiaryId) {
    const formData = getValues();
    setActiveDateFilter(false);
    const data = (structuredClone?.(formData) || JSON.parse(JSON.stringify(formData)))

    // Явно получаем commentKeyWords из формы, фильтруем пустые значения
    const commentKeyWords = Array.isArray(data.commentKeyWords) && data.commentKeyWords.length > 0 
      ? data.commentKeyWords.filter((word: string) => word && word.trim().length > 0)
      : [];

    const requestParams: DiaryRequestParams = {
      apiaryId,
      authorIds: data.authorIds || [],
      inspectedAtFrom: data.inspectedAtFrom || null,
      inspectedAtTo: data.inspectedAtTo || null,
      framesFrom: data.framesFrom || undefined,
      framesTo: data.framesTo || undefined,
      broodFrom: data.broodFrom || undefined,
      broodTo: data.broodTo || undefined,
      strengthFrom: data.strengthFrom || undefined,
      strengthTo: data.strengthTo || undefined,
      dictionariesIds: data.dictionariesIds || [],
      hasAttachments: data.hasAttachments !== undefined ? data.hasAttachments : null,
      commentKeywords: commentKeyWords.length > 0 ? commentKeyWords : undefined,
      hiveIds: data.hiveIds || [],
      sortBy: data.sortBy || 'updatedAt',
      sort: data.sort || 'DESC',
      page: {
        index: 0,
        size: pageSize
      }
    };

    if (areParamsEqual(lastRequestParams.current, requestParams))  {
      if (!ignoreEqual) return
    }
    
    lastRequestParams.current = requestParams;

    // Очищаем store перед новым запросом с фильтрами
    useDiaryStore.getState().clearEntries();

    //console.log('activeDate set to true in onDrawerSubmit: ',requestParams);

    const hasFilters = [
      requestParams.inspectedAtFrom,
      requestParams.inspectedAtTo,
      requestParams.framesFrom,
      requestParams.framesTo,
      requestParams.broodFrom,
      requestParams.broodTo,
      requestParams.strengthFrom,
      requestParams.strengthTo,
    ].some(Boolean);

    if (hasFilters) {
      setActiveDateFilter(true);
    }
    
    await getDiaryEntriesFromServer(requestParams).catch(console.warn);
    setIsFiltersOpen(false);
  }

  setShortFiltersLabel()
}
  

  const onDrawerSubmitDebounced = useDebounceCallback(() => {
    onDrawerSubmit(true);
  }, 1500)
  const onDateChange = (activeDate?: Date, secondDate?: Date) => {
    const inspectedAtFrom = activeDate && formatISO(activeDate);
    const inspectedAtTo = secondDate && formatISO(new Date(secondDate.getTime()).setHours(23, 59, 59));

    setValue('inspectedAtFrom', inspectedAtFrom || null);
    setValue('inspectedAtTo', inspectedAtTo || null);
    if (activeDate||secondDate) {
      onDrawerSubmit(true);
    }
  }

  const onDateBlur = () => {
    const activeDate = getValues('inspectedAtFrom');
    const secondDate = getValues('inspectedAtTo');
    if (activeDate||secondDate) {
      onDrawerSubmit(true);
    }
  }

  const openShortFilter = (selector: string) => {
    setShortFilterOpenSelector(selector);
  }

  const closeShortFilter = (submit?: boolean) => {
    setShortFilterOpenSelector(null);
    if (submit) {
      onDrawerSubmit();
    }
  }

  const onResetField = (selector: string) => {
    switch (selector) {
      case 'frames':
        resetField('framesFrom');
        resetField('framesTo');
        break;
      case 'strength':
        resetField('strengthFrom')
        resetField('strengthTo')
        break;
      case 'brood':
        resetField('broodFrom')
        resetField('broodTo')
        break;
      case 'dictionariesIds':
        setValue('dictionariesIds', []);
        break;
      case 'commentKeyWords':
        resetField('commentKeyWords')
        break;
      case 'hasAttachments':
        setValue('hasAttachments', null);
        break;
      case 'authorIds':
        setValue('authorIds', []);
        break;
    
      default:
        break;
    }

    closeShortFilter();
    setShortFiltersLabel();
    onDrawerSubmit(true);
  }

  const onResetAll = () => {
    reset();
    closeShortFilter();
    setShortFiltersLabel();
    onDrawerSubmit(true);
  }

  const onSortChange = (value: string) => {
    if (!value) {
      return setValue('sortBy', `${lastSortValue.current}`);
    }

    if (value.includes('-ASC')) {
      value = value.replace('-ASC', '');
      setValue('sort', 'ASC');
    } else {
      setValue('sort', 'DESC');
    }

    lastSortValue.current = `${value}`;
    setValue('sortBy', `${value}`);
    onDrawerSubmit(true);
  }

  const onAuthorClick = (id: string) => {
    const authorIds = getValues('authorIds');
    let newArr;
    if (authorIds.includes(id)) {
      newArr = authorIds.filter(el => el !== id);
    } else {
      newArr = [...authorIds, id];
    }

    setValue('authorIds', newArr);
  }

  useEffect(() => {
    onDrawerSubmit(true, true)
  }, [userInfo])

  useEffect(() => {
    setDictionaryItems(dictionaries.map(dictionary => {
      return {
        id: dictionary.id,
        name: dictionary.name,
        isSelected: getValues('dictionariesIds')?.includes(dictionary.id) || false
      }
    }))
  }, [dictionaries])

  return {
    control,
    isFiltersOpen,
    formValues,
    dictionaryItems,
    settedFiltersCounter,
    shortFilterOpenSelector,
    shortFiltersLabels,
    usersList: currentApiary()?.participants,
    setIsFiltersOpen,
    onDateChange,
    onDateBlur,
    onRangeChange,
    onResetItems,
    onDictionaryItemClick,
    onDictionaryReset,
    setHasAttachments,
    onDrawerClose,
    onDrawerSubmit,
    onCommentChange,
    onHivesChange,
    openShortFilter,
    closeShortFilter,
    onResetField,
    reset,
    onSortChange,
    onAuthorClick,
    onResetAll,
  }
}